import { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { WalletAddressContext } from '@/lib/walletContext'

export default function NavbarMyColonyLink({
  className,
  onNavigate,
  badge,
}: {
  className: (isActive: boolean) => string
  onNavigate?: () => void
  badge?: number
}) {
  const wallet = useContext(WalletAddressContext)
  if (!wallet)
    return null

  return (
    <NavLink
      to="/my-colony"
      onClick={onNavigate}
      className={({ isActive }) => className(isActive)}
    >
      My Colony
      {badge && badge > 0
        ? (
            <span className="rounded-full bg-lime-400/15 px-1.5 py-0.5 text-[10px] font-semibold text-lime-400">
              {badge}
            </span>
          )
        : null}
    </NavLink>
  )
}
